module.exports = require("lodash/range");